module.exports = "<app-home-navigate-bar></app-home-navigate-bar>\r\n<router-outlet></router-outlet>\r\n<app-MessageErrorDownload-popup></app-MessageErrorDownload-popup>\r\n<app-messageWithTextModal-popup></app-messageWithTextModal-popup>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main